var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.odp && _vm.odp.hourlyLoad)?_c('ul',{staticClass:"map-schedule__graphic"},_vm._l((this.hourLoad),function(item,i){return _c('li',{key:i,staticClass:"map-schedule__graphic-item",class:{
        'map-schedule__graphic-item_red': item.load === 4,
        'map-schedule__graphic-item_orange': item.load === 3,
        'map-schedule__graphic-item_yellow': item.load === 2,
        'map-schedule__graphic-item_green': item.load === 1,
      }},[(item.time.length === 4)?_c('span',[_vm._v("0"+_vm._s(item.time))]):_c('span',[_vm._v(_vm._s(item.time))])])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }